import { useState, useEffect } from "react";
import { useRequest } from "@danishagro/shared/src/hooks/useRequest.hook";

// 1. Request shape
export interface InventoryItemRequest {
    productNumber: string;
    variantId?: string;
}

// 2. Response shape
export interface InventoryItemResponse {
    productId: string; // <-- matches the real API field
    variantId?: string;
    quantityInStock: number;
    status: "HasInventory" | "NoInventoryData" | string;
    retailVariantId?: string;
}

// 3. Our custom hook
export const useInventoryVisibility = (items: InventoryItemRequest[]) => {
    const request = useRequest();

    const [data, setData] = useState<InventoryItemResponse[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        // If no items, skip the fetch
        if (!items || items.length === 0) return;

        setLoading(true);

        request
            .post("/inventoryvisibility", items) // returns a raw "Response"
            .then((response) => response.json()) // parse JSON ourselves
            .then((json: InventoryItemResponse[]) => {
                // Now we have typed data
                setData(json ?? []);
            })
            .catch((err) => {
                setError(err as Error);
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request, items]);

    return { data, loading, error };
};
